export default __webpack_public_path__ + "static/Kenya-heart-donation-1af4d682586480053ed52f8376a69042.png";